import React, { useEffect } from "react";
import {
  Box,
  Typography,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  Button,
} from "@mui/material";
import { CloseRounded } from "@mui/icons-material";
import { useDialog } from "../../../../DialogContext";
import { useDispatch, useSelector } from "react-redux";
import { getPracticeArea } from "../../../../../redux/Apps/Lawyerapp/CaseSlice/CaseSlice";
import { backend_api } from "../../../../../static/server";

const Header = ({
  tabBtn,
  templateName,
  setTemplateName,
  practiceAreaId,
  setPracticeAreaId,
  isReadonly,
  handleStartTour,
  placeType,
}) => {
  const { closeDialog } = useDialog();
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.user);
  const { allPracticeArea } = useSelector((state) => state.case);

  useEffect(() => {
    dispatch(
      getPracticeArea({
        url: `${backend_api}case/case-type/?case_service_type=practice_area`,
        token: token,
      })
    );
  }, [dispatch, token]);

  console.log(allPracticeArea);

  return (
    <Box
      id="Header"
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        px: "0.5rem",
        py: "0.2rem",
        bgcolor: "primary.main",
        position: "sticky",
        top: 0,
        zIndex: 10,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
          gap: "0.5rem",
          width: "100%",
        }}
      >
        <Typography
          variant="body1"
          color="white.main"
          sx={{
            fontSize: "1rem",
            whiteSpace: "nowrap",
          }}
        >
          {placeType === "MatterForm" ? "Create Mattter" : "Matter Template"}
        </Typography>
        {tabBtn === 1 &&
        (placeType === "createcaseTemplateForm") |
          (placeType === "previewForm") ? (
          <>
            <input
              type="text"
              readOnly={isReadonly}
              defaultValue={templateName}
              onChange={(e) => setTemplateName(e.target.value)}
              style={{
                border: "1px solid #e0e0e0",
                backgroundColor: "transparent",
                borderRadius: "0.3rem",
                padding: "0.2rem 0.5rem",
                fontSize: "0.9rem",
                fontWeight: "500",
                color: "white",
                textAlign: "center",
              }}
            />
            <FormControl
              size="small"
              readOnly={isReadonly}
              sx={{
                height: "2rem",
                borderRadius: "0.3rem",
                fontSize: "0.9rem",
                width: "10rem",
                color: "#fff",
              }}
            >
              <Select
                displayEmpty
                readOnly={isReadonly}
                inputProps={{ "aria-label": "Practice Area" }}
                value={practiceAreaId}
                onChange={(e) => setPracticeAreaId(e.target.value)}
                sx={{
                  height: "2rem",
                  backgroundColor: "transparent",
                  borderRadius: "0.3rem",
                  border: "1px solid #e0e0e0",
                  fontSize: "0.9rem",
                  color: "#fff",
                }}
              >
                <MenuItem value="">
                  <em>Practice Area</em>
                </MenuItem>
                {allPracticeArea?.map((option, i) => (
                  <MenuItem
                    key={i}
                    value={option.id}
                    sx={{ fontSize: "0.9rem" }}
                  >
                    {option.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </>
        ) : tabBtn === 1 && placeType === "MatterForm" ? (
          <>
            <FormControl
              size="small"
              readOnly={isReadonly}
              sx={{
                height: "2rem",
                borderRadius: "0.3rem",
                fontSize: "0.9rem",
                width: "10rem",
                color: "#fff",
              }}
            >
              <Select
                displayEmpty
                readOnly={isReadonly}
                inputProps={{ "aria-label": "Practice Area" }}
                value={practiceAreaId}
                onChange={(e) => setPracticeAreaId(e.target.value)}
                sx={{
                  height: "2rem",
                  backgroundColor: "transparent",
                  borderRadius: "0.3rem",
                  border: "1px solid #e0e0e0",
                  fontSize: "0.9rem",
                  color: "#fff",
                }}
              >
                <MenuItem value="">
                  <em>Practice Area</em>
                </MenuItem>
                {allPracticeArea?.map((option, i) => (
                  <MenuItem
                    key={i}
                    value={option.id}
                    sx={{ fontSize: "0.9rem" }}
                  >
                    {option.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </>
        ) : null}
      </Box>
      <Box sx={{ display: "flex", gap: "1rem" }}>
        {handleStartTour && (
          <Button
            id="start-tour-btn"
            onClick={() => handleStartTour()}
            variant="contained"
            color="secondary"
            size="small"
          >
            Start Tour
          </Button>
        )}
        <IconButton
          edge="start"
          color="white"
          size="small"
          aria-label="close"
          onClick={() => closeDialog()}
        >
          <CloseRounded />
        </IconButton>
      </Box>
    </Box>
  );
};

export default Header;
